/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CallerType } from '../../models/caller-type';
import { SeatmapSvgAndControlData } from '../../models/seatmap-svg-and-control-data';

export interface GetSeatmapFromOrder$Params {
  cartId?: string;
  orderId?: string;
  flightId: string;
  token?: string;
  currencyCode?: string;
  departureDateTime?: string;
  version?: number;

/**
 * Locale should be provided in 'ISO language code' or 'ISO language code'_'ISO country code' format. E.g. 'en' or 'en_US'. CoreMedia locale is supported but deprecated
 */
  locale?: string;
  rotation?: string;
  theme?: string;
  hash?: string;
  Caller?: CallerType;
}

export function getSeatmapFromOrder(http: HttpClient, rootUrl: string, params: GetSeatmapFromOrder$Params, context?: HttpContext): Observable<DapiHttpResponse<SeatmapSvgAndControlData>> {
  const rb = new DapiRequestBuilder(rootUrl, getSeatmapFromOrder.PATH, 'get');

  if (params) {
    rb.query('cartId', params.cartId, {});
    rb.query('orderId', params.orderId, {});
    rb.query('flightId', params.flightId, {});
    rb.query('token', params.token, {});
    rb.query('currencyCode', params.currencyCode, {});
    rb.query('departureDateTime', params.departureDateTime, {});
    rb.query('version', params.version, {});
    rb.query('locale', params.locale, {});
    rb.query('rotation', params.rotation, {});
    rb.query('theme', params.theme, {});
    rb.query('hash', params.hash, {});
    rb.header('Caller', params.Caller, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<SeatmapSvgAndControlData>;
    }),
    catchErrorAsJson()
  );
}

getSeatmapFromOrder.PATH = '/api/seatmap/by-order';
